import pluralize from "pluralize";

const getObjectiveChildrenCount = (objective, rawObjectives) => {
  if (!rawObjectives?.length) {
    return null;
  }

  const childCount = rawObjectives.filter((obj) =>
    obj.parentIds?.includes(objective.id)
  ).length;

  if (childCount === 0) {
    return null;
  }

  return {
    id: "childObjectives",
    icon: ["far", "bullseye"],
    label: `${childCount} ${pluralize("Goal", childCount)}`,
  };
};

export default getObjectiveChildrenCount;
